import BannerSelect from './BannerSelect'

export default BannerSelect



// WEBPACK FOOTER //
// ./src/components/BannerSelect/index.js